var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{
  'style-round': _vm.cornerStyle === 'round',
  'style-square': _vm.cornerStyle === 'square',
  'align-left': _vm.formattedWEBStoryLinkImage,
  fontLoaded: _vm.fontLoaded
}},[_c('button',{style:({ fontFamily: _vm.fontFamilyCSS }),on:{"click":function($event){return _vm.submit($event)}}},[(_vm.formattedWEBStoryLinkImage)?_c('div',{staticClass:"swimg"},[_c('img',{attrs:{"src":_vm.formattedWEBStoryLinkImage,"alt":_vm.WEBStoryLinkText}})]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.WEBStoryLinkText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }